// pages/CopyrightInformation.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom'; 
import { useEffect, useState ,useRef} from 'react';


const CopyrightInformation = () => {
     const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
          // const [isServicesOpen, setIsServicesOpen] = useState(false);
          // const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
          // const [isCompanyOpen, setIsCompanyOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
          };
        
          // const toggleServicesDropdown = () => {
          //   setIsServicesOpen(!isServicesOpen);
          // };
        
          // const toggleIndustriesDropdown = () => {
          //   setIsIndustriesOpen(!isIndustriesOpen);
          // };
        
          // const toggleCompanyDropdown = () => {
          //   setIsCompanyOpen(!isCompanyOpen);
          // };
  
      const [openDropdown, setOpenDropdown] = useState(null);
      const navRef = useRef(null);
    
      // Close dropdown on outside click
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (navRef.current && !navRef.current.contains(event.target)) {
            setOpenDropdown(null);
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
      }, []);
    
      const toggleDropdown = (dropdown) => {
        setOpenDropdown(openDropdown === dropdown ? null : dropdown);
      };
      
      const navigate = useNavigate();
     
      const handleClick = () => {
        navigate("/Contact#contact-section");
      };
        const [isOpen, setIsOpen] = useState(false);
              
                // const toggleDropdown = () => {
                //   setIsOpen((prev) => !prev);
                // };
          
          
                const [isServicesOpen, setIsServicesOpen] = useState(false);
            const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
            const [isCompanyOpen, setIsCompanyOpen] = useState(false);
          
            // Toggle functions for dropdowns
            const toggleServicesDropdown = () => {
              setIsServicesOpen(!isServicesOpen);
              setIsIndustriesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleIndustriesDropdown = () => {
              setIsIndustriesOpen(!isIndustriesOpen);
              setIsServicesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleCompanyDropdown = () => {
              setIsCompanyOpen(!isCompanyOpen);
              setIsServicesOpen(false);
              setIsIndustriesOpen(false); // Close other dropdowns
            };
                const [word, setWord] = useState('Today');
          
            useEffect(() => {
              const interval = setInterval(() => {
                setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
              }, 2000);
              return () => clearInterval(interval);
            }, []);
  


  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
    
    <div className="max-w-5xl mx-auto px-4 py-12 font-poppins text-gray-800">
      {/* Main heading */}
      <h1 className="text-4xl font-bold mb-4">Copyright Information</h1>

      {/* Lead sentence */}
      <p className="text-xl font-medium text-gray-700 mb-10">
        Protecting intellectual property is central to Lentera Technologies Private Limited.
      </p>

      <hr className="mb-10" />

      {/* 1 */}
      <h2 className="text-xl font-semibold mb-3">1. Copyright Ownership</h2>
      <p className="mb-6">
        All content and materials on the Lentera Technologies Private Limited website—including, but
        not limited to, text, graphics, images, logos, videos, software, and any other
        materials—are the property of Lentera Technologies Private Limited or its content providers
        and are protected by copyright laws.
      </p>

      {/* 2 */}
      <h2 className="text-xl font-semibold mb-3">2. Use of Content</h2>
      <p className="mb-6">
        Users are granted a limited, non‑exclusive, non‑transferable license to access and use the
        website solely for personal, non‑commercial purposes related to engaging with Lentera
        products and services. Users may <span className="font-semibold">not</span> reproduce,
        distribute, modify, display, perform, or create derivative works from any website content
        without explicit written permission from Lentera Technologies or the respective copyright
        owner.
      </p>

      {/* 3 */}
      <h2 className="text-xl font-semibold mb-3">3. Trademarks</h2>
      <p className="mb-6">
        The Lentera Technologies name, logo, and any other trademarks or service marks used on the
        site are the property of Lentera Technologies Private Limited and may not be used without
        prior written consent.
      </p>

      {/* 4 */}
      <h2 className="text-xl font-semibold mb-3">4. Copyright Infringement</h2>
      <p className="mb-4">
        Lentera Technologies Private Limited respects the intellectual‑property rights of others and
        expects its users to do the same. If you believe that any content on our site infringes your
        copyright, please contact us immediately with the following information:
      </p>
      <ul className="list-disc pl-6 space-y-2 mb-6 text-gray-700">
        <li>A description of the copyrighted work you believe has been infringed.</li>
        <li>The location (URL) of the allegedly infringing material on our website.</li>
        <li>Your contact information, including your name, address, telephone number, and email.</li>
        <li>
          A statement that you have a good‑faith belief the use is not authorized by the copyright
          owner, its agent, or the law.
        </li>
        <li>
          A statement, made under penalty of perjury, that the information above is accurate and
          that you are the copyright owner or authorized to act on the owner’s behalf.
        </li>
      </ul>

      {/* Contact */}
      <h2 className="text-xl font-semibold mb-3">Contact Information</h2>
      <p>
        If you have any questions or concerns about copyright or intellectual property on
        Lentera Technologies Private Limited, please reach out via the contact details listed on our
        website.
      </p>
    </div>
    
    </>
  );
};

export default CopyrightInformation;
